import { createContext, type RefObject } from 'react';

interface HoloStoreContextValue {
  alertBannerContainerRef?: RefObject<HTMLDivElement>;
  holoStoreRef?: RefObject<HTMLDivElement>;
}

const HoloStoreContext = createContext<HoloStoreContextValue | undefined>(undefined);

export default HoloStoreContext;
